<talk-to-your-data-collapsible-section
  title="Pinned Conversations"
  [count]="(savedConversations || []).length"
  icon="pin-filled"
>
  <ng-container *ngIf="(savedConversations || []).length > 0; else emptyState">
    <ul class="conversation-history__items conversation-history__items--saved">
      <li
        class="conversation-history__item"
        *ngFor="let item of savedConversations || []; let index = index; trackBy: trackByConversationId"
      >
        <talk-to-your-data-conversation-list-item
          [item]="item"
          [conversationId]="item.conversationId || item.id || ''"
          [testId]="'pinned-conversation-item-' + index"
          [selected]="(item.conversationId || item.id) === selectedConversationId"
          [pinned]="true"
          (conversationSelected)="onConversationSelected($event)"
          (actionSelected)="onMenuAction($event)"
        ></talk-to-your-data-conversation-list-item>
      </li>
    </ul>
  </ng-container>

  <ng-template #emptyState>
    <p class="conversation-history__empty">{{ 'certify.chatbot.history.pinnedEmpty' | translate }}</p>
  </ng-template>
</talk-to-your-data-collapsible-section>
